import { useEffect, useState } from 'react';
import { API_BASE } from '../config';

const WYLACZONE = Object.freeze({ wymiana: false });

/**
 * Zasady wynajmu firmy na ekranach, które tylko je czytają (kalendarz rezerwacji, kalendarz sztuki).
 * Lustro `czytajZasady` z lib/zasadyWynajmu.js: do czasu odpowiedzi i po awarii wszystko jest
 * wyłączone, więc firma, która niczego nie włączyła, widzi ekran jak dotąd. Ekran ustawień
 * (pages/RentalRules.js) czyta zasady sam, bo musi odróżnić awarię od zasad wyłączonych.
 */
export default function useZasadyWynajmu() {
  const [zasady, setZasady] = useState(WYLACZONE);

  useEffect(() => {
    let aktualne = true;
    (async () => {
      try {
        const res = await fetch(`${API_BASE}/api/rental-rules`, { credentials: 'include' });
        if (!res.ok) return;
        const dane = await res.json();
        if (aktualne) setZasady({ wymiana: dane?.same_day_exchange === true });
      } catch (_) {
        // Zostaje wyłączone: to tylko wygląd ekranu, kolizje liczy serwer.
      }
    })();
    return () => { aktualne = false; };
  }, []);

  return zasady;
}
